import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {APIv1} from "../../../api";
import currencyFormatted from "../../../utils/baseFormatter";
import Products from "../../Products/Products";
import {extractDateBySecond} from "../../../utils";
import ReceiptCheck from "../../../components/Orders/ReceiptChecks/ReceiptCheck";
import '../../../styles/BaseDetailStyle.scss';

const OrderDetail = () => {
    const {id} = useParams();
    const {t} = useTranslation();
    const [orderData, setOrderData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await APIv1.get(`orders/get/${id}`);
                const data = response.data;
                setOrderData(data);
            } catch (err) {
                console.error('Something went wrong:', err);
            }
        };
        fetchData();
    }, [id]);

    if (!orderData) {
        return <div>{t("pages.orders.detailColumns.errorNotFound")}</div>;
    }

    return (
        <section className="detail-view">
            <div className="detail-view__header">
                <div className="detail-view__title">
                    <h1 className="detail-view__main-title">{orderData.market_name}</h1>
                    <span className="detail-view__subtitle">
                        <span className="detail-view__subtitle-label">{t("common.deviceSerial")}: </span>
                        {orderData.cash_desc_serial}
                    </span>
                </div>
                <button
                    className="detail-view__action-button detail-view__action-button--secondary"
                    onClick={() => navigate(-1)}
                >
                    {t("pages.orders.detailColumns.button1")}
                </button>
            </div>

            <div className="detail-view__content--order">
                <div className="detail-view__section">
                    <h2 className="detail-view__section-title">{t("pages.orders.detailColumns.container1.title")}</h2>
                    <ul className="detail-view__list">
                        {[
                            {label: `${t("pages.orders.detailColumns.container1.row1")}`, value: orderData.market_name},
                            {label: `${t("common.inn")}`, value: orderData.inn},
                            {
                                label: `${t("pages.orders.detailColumns.container1.row2")}`,
                                value: orderData.number_result_url ?? t("common.notAvailable")
                            },
                            {label: `${t("pages.orders.detailColumns.container1.row3")}`, value: orderData.cashier},
                            {label: `${t("common.deviceSerial")}`, value: orderData.cash_desc_serial},
                            {
                                label: `${t("pages.orders.detailColumns.container1.row5")}`,
                                value: extractDateBySecond(orderData.created_date)
                            },
                        ].map(({label, value}) => (
                            <li key={label} className="detail-view__item">
                                <span className="detail-view__label">{label}:</span>
                                <span className="detail-view__value">{value}</span>
                            </li>
                        ))}
                        <li className="detail-view__item">
                            <span
                                className="detail-view__label">{t("pages.orders.detailColumns.container1.row6")}:</span>
                            <span
                                className="detail-view__value detail-view__value--highlighted">
                                {currencyFormatted(orderData.received_cash / 100)}
                            </span>
                        </li>
                        <li className="detail-view__item">
                            <span
                                className="detail-view__label">{t("pages.orders.detailColumns.container1.row7")}:</span>
                            <span
                                className="detail-view__value detail-view__value--highlighted">
                                {currencyFormatted(orderData.received_card / 100)}
                            </span>
                        </li>
                        <li className="detail-view__item detail-view__item--highlighted">
                            <span
                                className="detail-view__label">{t("pages.orders.detailColumns.container1.row8")}:</span>
                            <span
                                className="detail-view__value detail-view__value--highlighted">
                                {currencyFormatted((orderData.received_cash / 100) + (orderData.received_card / 100))}
                            </span>
                        </li>
                    </ul>

                    <div>
                        <h2 className="related-device-title">{t("pages.products.title")}</h2>
                        <Products related={true} defaultPageSize={10} orderId={id}/>
                    </div>
                </div>

                <div className="detail-view__receipt">
                    <ReceiptCheck orderData={orderData} orderId={id} t={t} type={orderData.type}/>
                </div>
            </div>
        </section>
    );
};

export default OrderDetail;
